import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import services from "../../services";

import {
  detalhesUsuario,
  editarUsuario,
  buscarUsuarios,
  logarUsuario,
} from "../../services/http/usuariosService";

import {
  Avatar,
  Divider,
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  message,
} from "antd";

import Header from "../../components/Header";
import ApiServicesLogin from "../../services/apiLogin";
import { phone, cnpj, cpf, cpfCnpj } from "../../services/mask";
import { validaCpfCnpj } from "../../services/validaCpfCnpj";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import lang from "../../assets/idioma/idiomas";
import globals from "../../globlas";

const PerfilUsuairo = () => {
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [form] = Form.useForm();
  const [usuario, setUsuario] = useState({});
  const [dadosFormulario, setDadosFormulario] = useState({
    nome: "",
    nomeUsuario: "",
    email: "",
    telefone: "",
    numeroTelefone: "",
    senha: "",
    confirmarSenha: "",
    cpfCnpj: "",
  });

  const [erros, setErros] = useState({});
  const [cpfCnpjValido, setCpfCnpjValido] = useState(false);
  const [idUsuario, setIdUsuario] = useState(null);
  const [admParticipante, setAdmParticipante] = useState("");

  useEffect(() => {
    
    IdUser && buscarDetalhes(IdUser)
  }, [IdUser]);

  
  const buscarDetalhes = (id) => {
    trackPromise(
      detalhesUsuario(id)
        .then((res) => {
          if (!res.fail && res.data) {
            const dadosMapeados = {
              nome: res?.data?.nome || "",
              nomeUsuario: res?.data?.login || "",
              email: res?.data?.email || "",
              telefone: res?.data?.phoneNumber || "",
              numeroTelefone: res?.data?.telefone || "",
              cpfCnpj: res?.data?.cpfCnpj,
            };
            setDadosFormulario(dadosMapeados);
            setAdmParticipante(res.data.nivelAcesso)
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const validarFormulario = () => {
    const novosErros = {};

    // Validação do nome (obrigatório para novo usuário)
    if (!dadosFormulario.nome?.trim()) {
      novosErros.nome = "Nome é obrigatório";
    }

    // Validação do nome de usuário (obrigatório para edição)
    if (!dadosFormulario.nomeUsuario?.trim()) {
      novosErros.nomeUsuario = "Usuário é obrigatório";
    }

    // Validação do email (obrigatório sempre)
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!dadosFormulario.email?.trim()) {
      novosErros.email = "Email é obrigatório";
    } else if (!regexEmail.test(dadosFormulario.email)) {
      novosErros.email = "Email inválido";
    }

    // Validação do telefone (obrigatório para novo usuário)
    if (!dadosFormulario.numeroTelefone?.trim()) {
      novosErros.numeroTelefone = "Telefone é obrigatório";
    }

    // Validação do CPF/CNPJ (obrigatório para novo usuário)
    if (!dadosFormulario.cpfCnpj?.trim()) {
      novosErros.cpfCnpj = "CPF/CNPJ é obrigatório";
    } else if (dadosFormulario.cpfCnpj && dadosFormulario.cpfCnpj.length > 0) {
      if (
        dadosFormulario.cpfCnpj.length !== 11 &&
        dadosFormulario.cpfCnpj.length !== 14
      ) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
      } else if (!validaCpfCnpj(dadosFormulario.cpfCnpj)) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
      }
    }

    // Validação da senha (obrigatória apenas para novo usuário)
    if(dadosFormulario.senha && dadosFormulario.senha.length < 6) {
      novosErros.senha = "A senha deve ter pelo menos 6 caracteres";
    }

    // Validação da confirmação de senha (obrigatória apenas se o campo senha estiver preenchido)
    if (dadosFormulario.senha) {
      if (!dadosFormulario.confirmarSenha) {
        novosErros.confirmarSenha = "Confirmação de senha é obrigatória";
      } else if (dadosFormulario.senha !== dadosFormulario.confirmarSenha) {
        novosErros.confirmarSenha = "As senhas não coincidem";
      }
    }


    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  // Manipulador de mudanças nos campos
  const alterarCampo = (evento) => {
    const { name, value, type, checked } = evento.target;

    if (name === "numeroTelefone" || name === "cpfCnpj") {
      const valorNumerico = value.replace(/\D/g, "");
      setDadosFormulario((anterior) => ({
        ...anterior,
        [name]: valorNumerico,
      }));
    } else {
      setDadosFormulario((anterior) => ({
        ...anterior,
        [name]: type === "checkbox" ? checked : value,
      }));
    }

    // Validação em tempo real para CPF/CNPJ
    if (name === "cpfCnpj") {
      const valorNumerico = value.replace(/\D/g, "");
      const novosErros = { ...erros };

      delete novosErros.cpfCnpj;

      if (
        valorNumerico.length > 0 &&
        valorNumerico.length !== 11 &&
        valorNumerico.length !== 14
      ) {
        novosErros.cpfCnpj =
          "CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos";
        setCpfCnpjValido(false);
      } else if (valorNumerico.length > 0 && !validaCpfCnpj(valorNumerico)) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
        setCpfCnpjValido(false);
      } else if (valorNumerico.length === 11 || valorNumerico.length === 14) {
        setCpfCnpjValido(true);
      } else {
        setCpfCnpjValido(false);
      }

      setErros(novosErros);
    } else {
      if (erros[name]) {
        setErros((anterior) => ({
          ...anterior,
          [name]: undefined,
        }));
      }
    }
  };

  
  

  // Limpar e formatar dados para a API
  const limparDadosParaAPI = (dados) => {
    return {
      email: dados.email?.trim() || "",
      nome: dados.nome?.trim() || "",
      cpfCnpj: dados.cpfCnpj?.trim() || "",
      telefone: dados.telefone?.trim() || "",
      status: dados.status,
      ...(dados.senha && { senha: dados.senha?.trim() }),
    };
  };

  // Validação específica para o formato da API
  const validarFormatoAPI = (dados) => {
    const erros = [];
    if (!dados.email?.trim()) {
      erros.push("Email é obrigatório");
    }

    if (!dados.nome?.trim()) {
      erros.push("Nome é obrigatório");
    }

    if (!dados.cpfCnpj?.trim()) {
      erros.push("CPF/CNPJ é obrigatório");
    }

    if (!dados.telefone?.trim()) {
      erros.push("Telefone é obrigatório");
    }

    return erros;
  };

  // Submissão do formulário
  const enviarFormulario = async (evento) => {
    evento.preventDefault();

    if (!validarFormulario()) {
      return;
    }

    try {

      console.log(dadosFormulario)
      const dadosBrutos = {
        id:IdUser,
        email: dadosFormulario.email,
        nome: dadosFormulario.nome,
        cpfCnpj: dadosFormulario.cpfCnpj,
        senha: dadosFormulario.senha,
        telefone: dadosFormulario.numeroTelefone,
        senha: dadosFormulario.senha == "" ? null : dadosFormulario.senha,
      };
      
      const dadosParaEnvio = limparDadosParaAPI(dadosBrutos);
      const errosAPI = validarFormatoAPI({ ...dadosParaEnvio });
      if (errosAPI.length > 0) {
        message.error(`Erros de validação: ${errosAPI.join(", ")}`);
        return;
      }

      await ApiServicesLogin.apiPost(`Usuario/editar-usuario`, {
        ...dadosParaEnvio,
        id: IdUser,
      });
      admParticipante == "Participante" ? message.success(lang.Participante_alterado_com_sucesso):
      message.success(lang.Administrador_alterado_com_sucesso);
    } catch (erro) {
      console.error("Erro ao salvar usuário:", erro);
      // Verificar se é um erro de usuário já existente
      if (erro.response?.data?.message) {
        message.error(erro.response.data.message);
      }
    }
  };


  return (
    <>
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />

      <div className="container">
        <h1 className="title">Editar {admParticipante == "Participante" ? "Participante" : "Administrador" }</h1>
        <form onSubmit={enviarFormulario} className="admin-form">
          <div className="form-section">
            <h2>Dados Pessoais</h2>
            <div className="row">
              {/* NOME */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Nome</label>
                  <input
                    type="text"
                    name="nome"
                    value={dadosFormulario.nome}
                    onChange={alterarCampo}
                    className={`form-control ${erros.nome ? "is-invalid" : ""}`}
                  />
                  {erros.nome && (
                    <div className="invalid-feedback">{erros.nome}</div>
                  )}
                </div>
              </div>
              {/* USUARIO */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>
                    Usuário
                  </label>
                  <input
                    type="text"
                    name="nomeUsuario"
                    value={dadosFormulario.nomeUsuario}
                    onChange={alterarCampo}
                    disabled
                    className={`form-control ${erros.nomeUsuario ? "is-invalid" : ""
                      }`}
                  />
                  {erros.nomeUsuario && (
                    <div className="invalid-feedback">{erros.nomeUsuario}</div>
                  )}
                </div>
              </div>

              {/* CPF/CNPJ */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>CPF/CNPJ</label>
                  <input
                    type="text"
                    name="cpfCnpj"
                    value={cpfCnpj(dadosFormulario.cpfCnpj)}
                    onChange={alterarCampo}
                    maxLength={18}
                    className={`form-control ${erros.cpfCnpj
                        ? "is-invalid"
                        : cpfCnpjValido
                          ? "is-valid"
                          : ""
                      }`}
                  />
                  {erros.cpfCnpj && (
                    <div className="invalid-feedback">{erros.cpfCnpj}</div>
                  )}
                  {cpfCnpjValido && !erros.cpfCnpj && (
                    <div className="valid-feedback">CPF/CNPJ válido</div>
                  )}
                </div>
              </div>
              {/* EMAIL */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={dadosFormulario.email}
                    onChange={alterarCampo}
                    required
                    className={`form-control ${erros.email ? "is-invalid" : ""
                      }`}
                  />
                  {erros.email && (
                    <div className="invalid-feedback">{erros.email}</div>
                  )}
                </div>
              </div>
              {/* TELEFONE */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Telefone</label>
                  <input
                    type="text"
                    name="numeroTelefone"
                    value={phone(dadosFormulario.numeroTelefone)}
                    onChange={alterarCampo}
                    className={`form-control ${erros.numeroTelefone ? "is-invalid" : ""
                      }`}
                  />
                  {erros.numeroTelefone && (
                    <div className="invalid-feedback">
                      {erros.numeroTelefone}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Dados de Acesso</h2>
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>
                    Senha
                  </label>
                  <input
                    type="password"
                    name="senha"
                    value={dadosFormulario.senha}
                    onChange={alterarCampo}
                    className={`form-control ${erros.senha ? "is-invalid" : ""
                      }`}
                    placeholder={
                      "Deixe em branco para manter a senha atual"
                    }
                  />
                  {erros.senha && (
                    <div className="invalid-feedback">{erros.senha}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>
                    Confirmar Senha
                  </label>
                  <input
                    type="password"
                    name="confirmarSenha"
                    value={dadosFormulario.confirmarSenha}
                    onChange={alterarCampo}
                    className={`form-control ${erros.confirmarSenha ? "is-invalid" : ""
                      }`}
                    placeholder={
                      "Deixe em branco para manter a senha atual"
                    }
                  />
                  {erros.confirmarSenha && (
                    <div className="invalid-feedback">
                      {erros.confirmarSenha}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mt-4">
            <div className="col-md-3 col-sm-6 mb-3">
              <button type="submit" className="btn btn-primary w-100">
                Salvar
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default PerfilUsuairo;
